<div class="d-flex flex-column justify-content-center">
    <ng-container>
        <div mat-dialog-actions class="w-100 justify-content-center">
            <mat-spinner class="mb-4 loading-spinner"></mat-spinner>
        </div>
        <span>{{'spinner.please_wait'|translate}}</span>
    </ng-container>
</div>
